/* eslint-disable */
import React, { useState } from 'react';
import DevsPop from './DevsPop';
import DevsOptionList from './DevsOptionList';
import p from './devsPop.module.css';
import { Ic } from './devsIcons';
import { AXIS_NAME, POP_AXES, BAR_AXES, FLAGS, FLAG_AXIS, axisValues, labelOf, plural, fmt } from './devsBarModel';

// DevsFiltersPopover — every axis in one place: sections on the left (the three that also sit on the
// bar come last, under "Also on the bar"), the chosen section's list on the right, counts live.
// On a phone it is a bottom sheet with the sections as a row of tabs. One state: it reads and writes
// the same devFilters the bar's own dropdowns and the chips do (Convention #141).
export default function DevsFiltersPopover({ model, onClose }) {
  const { opts, devFilters, facets, ready, flagCounts, nSel, toggle, only, clearAxis, clearAll, anyActive, matched } = model;
  const first = POP_AXES.find((k) => axisValues(devFilters, k).length) || POP_AXES[0];
  const [sec, setSec] = useState(first);
  const sel = axisValues(devFilters, sec);
  const listOpts = sec === FLAG_AXIS ? FLAGS : (opts[sec] || []);
  const counts = sec === FLAG_AXIS ? flagCounts : (facets.axes[sec] || {});
  const sepAt = POP_AXES.length - BAR_AXES.length;
  return (
    <DevsPop anchorKey="filters" kind="fp" label="Filters" onClose={onClose}>
      <div className={p.ph}><span className={p.pt}>Filters</span><span className={p.pmu}>{nSel ? plural(nSel, 'choice') : 'Nothing chosen yet'}</span><button type="button" className={p.px} aria-label="Close filters" onClick={onClose}><Ic n="x" /></button></div>
      <div className={p.fpb}>
        <nav className={p.fnav} aria-label="Filter sections">
          {POP_AXES.map((k, i) => {
            const s = axisValues(devFilters, k), sum = s.length === 0 ? 'Any' : s.length === 1 ? labelOf(opts, k, s[0]) : `${s.length} chosen`;
            return (
              <React.Fragment key={k}>
                {i === sepAt && <div className={p.fsep}>Also on the bar</div>}
                <button type="button" data-nav className={`${p.fn} ${sec === k ? p.on : ''} ${s.length ? p.has : ''}`} aria-pressed={sec === k} onClick={() => setSec(k)}><span className={p.a}>{AXIS_NAME[k]}</span><span className={p.s}>{sum}</span></button>
              </React.Fragment>
            );
          })}
        </nav>
        <div className={p.fsec}>
          <div className={`${p.ph}`}><span className={p.pt}>{AXIS_NAME[sec]}</span>{sel.length ? <button type="button" className={p.lnk} onClick={() => clearAxis(sec)}>Clear {AXIS_NAME[sec].toLowerCase()}</button> : <span className={p.pmu}>{sec === FLAG_AXIS ? 'Overlays on any stage' : 'Pick one or more'}</span>}</div>
          <DevsOptionList key={sec} axis={sec} name={AXIS_NAME[sec]} options={listOpts} selected={sel} counts={counts} ready={ready} onToggle={toggle} onOnly={only} />
        </div>
      </div>
      <div className={p.pf}><button type="button" className={p.lnk} disabled={!anyActive} onClick={clearAll}>Clear all</button><span className={p.pmu}><b>{ready ? fmt(matched) : '–'}</b> {matched === 1 ? 'dev' : 'devs'}</span><button type="button" className={p.done} onClick={onClose}>Done</button></div>
    </DevsPop>
  );
}
